import { useEffect, useMemo, useState } from 'react';
import { DEFAULT_CULTURE } from 'src/constants';
import { useProductVersions } from 'src/hooks/useProductVersions';
import { buildGalleryUrl } from 'src/util/galleryUrlBuilder';
import { CultureSplitButton } from './CultureSplitButton';

interface Props {
    strategy: Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy;
    selectedVariantIndex: number;
}

export const ViewStrategyButton = ({ strategy, selectedVariantIndex }: Props): JSX.Element => {
    const [selectedCulture, setSelectedCulture] = useState('');
    const { currentProductVersion } = useProductVersions(strategy.referenceProduct);
    const cultures = useMemo(
        () => strategy.cultureVariantRankings?.[selectedVariantIndex]?.cultures ?? [],
        [strategy, selectedVariantIndex],
    );

    useEffect(() => {
        if (cultures.includes(DEFAULT_CULTURE)) {
            setSelectedCulture(DEFAULT_CULTURE);
        } else {
            setSelectedCulture(cultures[0] ?? '');
        }
    }, [cultures]);

    const isDisabled = !strategy.name || !strategy.referenceProduct || cultures.length === 0;
    const url = buildGalleryUrl(
        selectedCulture,
        strategy.referenceProduct,
        currentProductVersion ?? undefined,
        strategy.name,
    );

    return (
        <CultureSplitButton
            ariaLabel="View Strategy Button"
            cultures={cultures}
            disabled={isDisabled}
            label="View Live Strategy"
            selectedCulture={selectedCulture}
            tooltip={
                isDisabled
                    ? 'Add all necessary fields and save to view this strategy in a gallery.'
                    : 'Select a culture to view this strategy in a gallery. Please allow up to 10 minutes after saving for the ranking to take effect.'
            }
            onClick={(): void => { window.open(url, '_blank')?.focus(); }}
            onSelectCulture={setSelectedCulture}
        />
    );
};
